import {apiLog} from './utils.js';

declare const PRODUCT_NAME;

export const enum MessageId {
    OVERLAY_STATE = 'OVERLAY_STATE',
    AUTHENTICATION_STATE = 'AUTHENTICATION_STATE',
}

interface Message {
    origin?: string;
    id: MessageId;
}

export interface OverlayState extends Message {
    shown: boolean;
}

export interface AuthenticationState extends Message {
    authenticated: boolean;
}

export function postMessage(message: OverlayState | AuthenticationState) {
    message.origin = PRODUCT_NAME;
    apiLog.debug('POST MESSAGE', message);
    window.postMessage(message);
}
